import { z } from 'zod';
/**
 * `GET /api/web/visitor/usage/monthly-visits` — this tenant's check-ins in the current CALENDAR
 * MONTH, UTC, against its `visitor.monthly_visits` cap. What the admin dashboard's usage banner
 * reads.
 *
 * THE CAP IS SOFT (`entitlement.ts`, `visitor.monthly_visits`): a check-in is never refused.
 * Past `limit`, arrival notifications are skipped for the rest of the month, which is the one
 * consequence the banner exists to explain before it surprises a host.
 *
 * `limit === null` MEANS UNLIMITED and must never be rendered as zero — the same contract every
 * limit-shaped entitlement carries. `used` is still reported for an unlimited tenant.
 *
 * `periodStart` is inclusive and `periodEnd` exclusive (the first instant of next month), both
 * ISO-8601 UTC, so a client can say "resets on <date>" without knowing the server's clock rule.
 */
export const monthlyVisitUsageDTOSchema = z.object({
    used: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative().nullable(),
    periodStart: z.string().datetime(),
    periodEnd: z.string().datetime(),
});
/**
 * The share of the cap at which the dashboard starts warning (80%), and the point past which
 * alerts are paused (100%). A contract constant so the banner and any later email agree.
 */
export const MONTHLY_VISIT_USAGE_WARN_RATIO = 0.8;
export function monthlyVisitUsageLevel(usage) {
    if (usage.limit === null)
        return 'ok';
    if (usage.used >= usage.limit)
        return 'exhausted';
    if (usage.used >= Math.ceil(usage.limit * MONTHLY_VISIT_USAGE_WARN_RATIO))
        return 'warning';
    return 'ok';
}
//# sourceMappingURL=visitor-monthly-visit-usage.js.map